import { render } from "./AnnotationDetails.vue?vue&type=template&id=2bd29150&scoped=true"
import script from "./AnnotationDetails.vue?vue&type=script&lang=js"
export * from "./AnnotationDetails.vue?vue&type=script&lang=js"

import "./AnnotationDetails.vue?vue&type=style&index=0&id=2bd29150&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd29150"]])

export default __exports__